import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Catalogue from "./pages/Catalogue";
import BraidPage from "./pages/BraidPage";
import BookingAgreement from "./pages/BookingAgreement";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Contact from "./pages/Contact";
import MyAppointments from "./pages/MyAppointments";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <div className="app-shell">
        <Navbar />

        <Routes>
          <Route path="/" element={<Catalogue />} />

          <Route path="/braids/:id" element={<BraidPage />} />

          <Route
            path="/booking-agreement"
            element={<BookingAgreement />}
          />

          <Route
            path="/my-appointments"
            element={<MyAppointments />}
          />

          <Route path="/terms" element={<Terms />} />

          <Route path="/privacy" element={<Privacy />} />

          <Route path="/contact" element={<Contact />} />
        </Routes>

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;